import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import logo from "../assets/images/logo/logoW.png";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  // Close menu on route change
  useEffect(() => {
    setIsMenuOpen(false);
  }, [location]);

  // Prevent body scroll when menu is open
  useEffect(() => {
    if (isMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    
    // Cleanup
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isMenuOpen]);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <>
      <header className="bg-transparent relative z-40 pt-4 sm:pt-6 md:pt-8 lg:pt-10">
        <div className="w-full max-w-[1792px] mx-auto px-4 sm:px-6 md:px-8 lg:px-12 xl:px-16">
          <div className="flex items-center justify-between h-[50px] sm:h-[55px] md:h-[60px]">
            {/* Logo - Responsive sizing */}
            <div className="flex items-center flex-shrink-0">
              <Link to="/" className="flex items-center" onClick={closeMenu}>
                <img
                  src={logo}
                  alt="Hair To Dye For Logo"
                  className="w-[160px] h-[26px] sm:w-[200px] sm:h-[32px] md:w-[250px] md:h-[39px] lg:w-[299px] lg:h-[47px] object-contain"
                />
              </Link>
            </div>

            {/* Desktop Navigation - Hidden on smaller screens */}
            <nav className="hidden xl:flex items-center gap-4 lg:gap-6 xl:gap-8 2xl:gap-10">
              <Link 
                to="/about" 
                className={`text-white hover:opacity-80 transition-opacity font-montserrat font-normal text-sm lg:text-base uppercase tracking-[0.15em] lg:tracking-[0.2em] leading-[100%] whitespace-nowrap relative pb-2 ${
                  isActive('/about') ? 'after:content-[""] after:absolute after:bottom-0 after:left-0 after:right-0 after:h-[2px] after:bg-white' : ''
                }`}
              >
                ABOUT
              </Link>
              <Link 
                to="/services" 
                className={`text-white hover:opacity-80 transition-opacity font-montserrat font-normal text-sm lg:text-base uppercase tracking-[0.15em] lg:tracking-[0.2em] leading-[100%] whitespace-nowrap relative pb-2 ${
                  isActive('/services') ? 'after:content-[""] after:absolute after:bottom-0 after:left-0 after:right-0 after:h-[2px] after:bg-white' : ''
                }`}
              >
                SERVICES
              </Link>
              <Link 
                to="/artists" 
                className={`text-white hover:opacity-80 transition-opacity font-montserrat font-normal text-sm lg:text-base uppercase tracking-[0.15em] lg:tracking-[0.2em] leading-[100%] whitespace-nowrap relative pb-2 ${
                  isActive('/artists') ? 'after:content-[""] after:absolute after:bottom-0 after:left-0 after:right-0 after:h-[2px] after:bg-white' : ''
                }`}
              >
                ARTISTS
              </Link>
              <Link 
                to="/gallery" 
                className={`text-white hover:opacity-80 transition-opacity font-montserrat font-normal text-sm lg:text-base uppercase tracking-[0.15em] lg:tracking-[0.2em] leading-[100%] whitespace-nowrap relative pb-2 ${
                  isActive('/gallery') ? 'after:content-[""] after:absolute after:bottom-0 after:left-0 after:right-0 after:h-[2px] after:bg-white' : ''
                }`}
              >
                GALLERY
              </Link>
              <Link 
                to="/faq" 
                className={`text-white hover:opacity-80 transition-opacity font-montserrat font-normal text-sm lg:text-base uppercase tracking-[0.15em] lg:tracking-[0.2em] leading-[100%] whitespace-nowrap relative pb-2 ${
                  isActive('/faq') ? 'after:content-[""] after:absolute after:bottom-0 after:left-0 after:right-0 after:h-[2px] after:bg-white' : ''
                }`}
              >
                FAQ
              </Link>
              <Link 
                to="/contact" 
                className={`text-white hover:opacity-80 transition-opacity font-montserrat font-normal text-sm lg:text-base uppercase tracking-[0.15em] lg:tracking-[0.2em] leading-[100%] whitespace-nowrap relative pb-2 ${
                  isActive('/contact') ? 'after:content-[""] after:absolute after:bottom-0 after:left-0 after:right-0 after:h-[2px] after:bg-white' : ''
                }`}
              >
                CONTACT US
              </Link>
               <a
  href="tel:+16109233530" 
                className="bg-[#C7A064] text-[#FAFAFA] px-4 lg:px-6 xl:px-7 py-2.5 lg:py-3 rounded-[40px] font-montserrat font-semibold text-sm lg:text-base uppercase tracking-[0.15em] lg:tracking-[0.2em] leading-[100%] whitespace-nowrap hover:bg-[#B3925A] transition-colors flex items-center justify-center"
              >
                CALL TO BOOK NOW
              </a>
            </nav>

            {/* Mobile Menu Button - Hamburger Icon */}
            <button
              onClick={toggleMenu}
              className="xl:hidden relative z-50 p-2 -mr-2"
              aria-label="Toggle menu"
            >
              <div className="w-6 h-5 relative flex flex-col justify-between">
                <span 
                  className={`block h-0.5 w-full bg-white transform transition-all duration-300 origin-left ${
                    isMenuOpen ? 'rotate-45 translate-x-px' : ''
                  }`}
                />
                <span 
                  className={`block h-0.5 w-full bg-white transition-all duration-300 ${
                    isMenuOpen ? 'opacity-0 scale-x-0' : ''
                  }`}
                />
                <span 
                  className={`block h-0.5 w-full bg-white transform transition-all duration-300 origin-left ${
                    isMenuOpen ? '-rotate-45 translate-x-px' : ''
                  }`}
                />
              </div>
            </button>
          </div>
        </div>
      </header>

      {/* Mobile Menu Overlay - Outside of header with highest z-index */}
      {isMenuOpen && (
        <>
          {/* Backdrop */}
          <div 
            className="xl:hidden fixed inset-0 bg-black/50 backdrop-blur-sm"
            style={{ zIndex: 99998 }}
            onClick={closeMenu}
          />
          
          {/* Menu Panel */}
          <div 
            className="xl:hidden fixed inset-0 bg-black"
            style={{ zIndex: 99999 }}
          >
            <div className="flex flex-col h-full overflow-y-auto">
              {/* Mobile Menu Header with Logo and Close */}
              <div className="flex items-center justify-between px-4 sm:px-6 pt-4 sm:pt-6 md:pt-8">
                <Link to="/" onClick={closeMenu}>
                  <img
                    src={logo}
                    alt="Hair To Dye For Logo"
                    className="w-[160px] h-[26px] sm:w-[200px] sm:h-[32px] object-contain"
                  />
                </Link>
                <button
                  onClick={closeMenu}
                  className="p-2 -mr-2"
                  aria-label="Close menu"
                >
                  <div className="w-6 h-6 relative">
                    <span className="absolute inset-0 flex items-center justify-center">
                      <span className="block w-6 h-0.5 bg-white rotate-45 absolute" />
                      <span className="block w-6 h-0.5 bg-white -rotate-45 absolute" />
                    </span>
                  </div>
                </button>
              </div>
              
              {/* Mobile Menu Navigation */}
              <nav className="flex-1 flex flex-col items-center justify-center px-8 py-8 space-y-6 sm:space-y-8">
                <Link 
                  to="/" 
                  className={`text-white hover:text-[#C7A064] transition-colors font-montserrat font-normal text-lg sm:text-xl uppercase tracking-[0.2em] ${
                    isActive('/') ? 'text-[#C7A064]' : ''
                  }`}
                  onClick={closeMenu}
                >
                  HOME
                </Link>
                <Link 
                  to="/about" 
                  className={`text-white hover:text-[#C7A064] transition-colors font-montserrat font-normal text-lg sm:text-xl uppercase tracking-[0.2em] ${
                    isActive('/about') ? 'text-[#C7A064]' : ''
                  }`}
                  onClick={closeMenu}
                >
                  ABOUT
                </Link>
                <Link 
                  to="/services" 
                  className={`text-white hover:text-[#C7A064] transition-colors font-montserrat font-normal text-lg sm:text-xl uppercase tracking-[0.2em] ${
                    isActive('/services') ? 'text-[#C7A064]' : ''
                  }`}
                  onClick={closeMenu}
                >
                  SERVICES
                </Link>
                <Link 
                  to="/artists" 
                  className={`text-white hover:text-[#C7A064] transition-colors font-montserrat font-normal text-lg sm:text-xl uppercase tracking-[0.2em] ${
                    isActive('/artists') ? 'text-[#C7A064]' : ''
                  }`}
                  onClick={closeMenu}
                >
                  ARTISTS
                </Link>
                <Link 
                  to="/gallery" 
                  className={`text-white hover:text-[#C7A064] transition-colors font-montserrat font-normal text-lg sm:text-xl uppercase tracking-[0.2em] ${
                    isActive('/gallery') ? 'text-[#C7A064]' : ''
                  }`}
                  onClick={closeMenu}
                >
                  GALLERY
                </Link>
                <Link 
                  to="/faq" 
                  className={`text-white hover:text-[#C7A064] transition-colors font-montserrat font-normal text-lg sm:text-xl uppercase tracking-[0.2em] ${
                    isActive('/faq') ? 'text-[#C7A064]' : ''
                  }`}
                  onClick={closeMenu}
                >
                  FAQ
                </Link>
                <Link 
                  to="/contact" 
                  className={`text-white hover:text-[#C7A064] transition-colors font-montserrat font-normal text-lg sm:text-xl uppercase tracking-[0.2em] ${
                    isActive('/contact') ? 'text-[#C7A064]' : ''
                  }`}
                  onClick={closeMenu}
                >
                  CONTACT US
                </Link>
                
                {/* CTA Button in Mobile Menu */}
                 <a
  href="tel:+16109233530" 
                  className="bg-[#C7A064] text-[#FAFAFA] px-6 sm:px-8 py-3 sm:py-4 rounded-[40px] font-montserrat font-semibold text-base sm:text-lg uppercase tracking-[0.2em] hover:bg-[#B3925A] transition-colors mt-4 sm:mt-6"
                  onClick={closeMenu}
                >
                  CALL TO BOOK NOW
                </a>
              </nav>
              
              {/* Footer info */}
              <div className="pb-8 text-center">
                <p className="text-white/60 text-sm">
                  200 Northampton St, Easton, PA
                </p>
                <p className="text-white/60 text-sm mt-1">
                  (610) 923-3530
                </p>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default Header;